const getOptinBadgeStatus = (flag:string) => {
    if (!flag) return "M"
    if (flag.includes('I')) return "Y"
    if (flag.includes('N')) return "R"
    if (flag.includes('Y')) return "G"
    return ""
}

export default getOptinBadgeStatus